export const getFileSizeMB = (file: File): number => {
  return file.size / (1024 * 1024);
};
